import Flickity from 'flickity';

/**
 * Set up sliders.
 */
class IconicSliders {
	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		'slider': '.carousel',
		'slides': '.carousel-cell'
	};

	/**
	 * Run panels.
	 */
	constructor() {
		this.addReadyClass();
		this.watchClicks();
	};

	/**
	 * Add ready class.
	 */
	addReadyClass = () => {
		Flickity.prototype._createReadyClass = function() {
			this.element.classList.add( 'flickity-ready' );
		};

		Flickity.createMethods.push( '_createReadyClass' );

		var resize = Flickity.prototype.resize;

		Flickity.prototype.resize = function() {
			this.element.classList.remove( 'flickity-ready' );
			resize.call( this );
			this.element.classList.add( 'flickity-ready' );
		};
	};

	/**
	 * Watch for slide clicks.
	 */
	watchClicks = () => {
		document.querySelectorAll( this.classes.slides ).forEach( ( slide ) => {
			[ 'click', 'touchstart' ].forEach( ( e ) => {
				slide.addEventListener( e, () => {
					// get carousel: .carousel
					let slider = slide.closest( this.classes.slider );
					let flickity = Flickity.data( slider );

					flickity.select( parseInt( slide.dataset.index ) );
				} );
			} );
		} );
	};
}

export {IconicSliders};